<script lang="ts">
	import TechnologyStackCard from "$components/TechnologyStackCard.svelte";

	export let data: object = [];
	export let title: string | '' = 'Technologies we use';
	export let description: string | '' =
		'Our tech stack includes both cutting-edge and time-tested technologies. This combo allows us to deliver software solutions that make a real difference for our clients’ businesses.';
</script>

<div class="technologies-bg">
	<article class="container">
		<div class="section-title flex-column-center">
			<h2>{@html title}</h2>
		</div>
		
		<p class="h5">{@html description}</p>
		
		<div class="stack-list flex-row">
			{#each data as item}
				<TechnologyStackCard
					data="{item}"
				/>
			{/each}
		</div>
	</article>
</div>

<style lang="scss">
	@import '$styles/vars';

	.technologies-bg {
		padding-top: 60px;
		padding-bottom: 60px;
		background: url("/technologies-bg.webp") center/cover no-repeat;
	}

	article, .section-title {
		color: $main-white;
	}

	article {
		display: flex;
		flex-direction: column;
		align-items: center;

		.h5 {
			text-align: center;
			max-width: 70%;
		}

		.stack-list {
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			width: 100%;
			margin-top: 48px;
			column-gap: 30px;
		}
	}

	@media (max-width: $landscape-phone-size) {
		article {
			.h5 {
				max-width: 100%;
			}

			.stack-list {
				display: flex;
				flex-direction: column;
				row-gap: 24px;
				box-sizing: border-box;
				margin-top: 0;
			}
		}
	}

	@media (min-width: $portrait-phone-size) and (max-width: $tablet-size) {
		article {
			.stack-list {
				column-gap: 20px;
			}
		}
	}
</style>
